import { selectAgentV2ActiveCitationId } from '@/agent-v2/references/store/selectors'
import { useAppSelector } from '@/store/store-hooks'
import { useChatPanelTabs } from './useChatPanelTabs'

/** Which citation to highlight in the draft document. */
export function useDraftActiveCitationId(): string | null {
  // Visible rather than just open: while the panel is on the conversation tab, its source highlights nothing.
  const { sourceVisible } = useChatPanelTabs()
  const activeCitationId = useAppSelector(selectAgentV2ActiveCitationId)

  return sourceVisible ? activeCitationId : null
}
